import { ServiceTechDashboard } from '@/pages/dashboard/executive/ServiceTechDashboard';
import { MyTicketsPage } from '@/pages/executive/service/MyTicketsPage';
import { PartsAndExpensesPage } from '@/pages/executive/service/PartsAndExpensesPage';
import { ProfileWarrantyLookup, ProfileServiceTicketDetail } from './ProfileServiceRoute';
import { Route, Navigate } from 'react-router-dom';
import * as Pages from './routePages';
import { DEALER_PAGE_ROLES } from '../lib/roles';
import { RequireRoles, RequireCapability, BlockReps, StrictViewBlock, RoleAwareHome, RoleAwareDashboard } from './routingGuards';
import { NoAccessPage } from '../components/auth/ProfileRouteGuard';
export function peopleRoutes() {
  return <>
<Route path="/service/my-day" element={<ServiceTechDashboard/>}/>
<Route path="/service/my-tickets" element={<MyTicketsPage/>}/>
<Route path="/service/parts" element={<PartsAndExpensesPage/>}/>
<Route path="/service/installations" element={<Pages.ITBPInstallationsPage/>}/>
<Route path="/service/installations/:id" element={<Pages.InstallationJobDetailPage/>}/>
<Route path="/warranty-lookup" element={<ProfileWarrantyLookup/>}/>
<Route path="/service/sop-dashboard" element={<Pages.ServiceSOPDashboardPage />} />
<Route path="/service/complaints/:id" element={<Pages.ComplaintDetailPage />} />
<Route path="/service/itbp-installations" element={<Pages.ITBPInstallationsPage />} />
<Route path="/service/itbp-installations/:id" element={<Pages.InstallationJobDetailPage />} />
<Route path="/service/itbp-reports" element={<Pages.ITBPReportsPage />} />
<Route path="/service-tickets" element={<Pages.ServiceTicketsPage />} />
<Route path="/service-tickets/new" element={<Pages.ServiceTicketCreatePage />} />
<Route path="/service-tickets/:id" element={<ProfileServiceTicketDetail />} />
<Route path="/service-tickets/:id/components" element={<Pages.ComponentIssuePage />} />
<Route path="/service-tickets/:id/photos" element={<Pages.ServicePhotosPage />} />
<Route path="/service-tickets/:id/audit" element={<Pages.ServiceAuditPage />} />
<Route path="/service-tickets/:id/otp" element={<Pages.OtpVerifyPage />} />
<Route path="/service/intake" element={<Pages.ComplaintIntakePage />} />
<Route path="/service/warranty-verify/:id" element={<Pages.WarrantyVerificationPage />} />
<Route path="/service/pre-visit/:id" element={<Pages.PreVisitChecklistPage />} />
<Route path="/service/diagnosis/:id" element={<Pages.ProductDiagnosisPage />} />
<Route path="/service/on-site/:id" element={<Pages.OnSiteExecutionPage />} />
<Route path="/service/warranty-claim/:id" element={<Pages.WarrantyClaimPage />} />
<Route path="/warranties" element={<Pages.WarrantiesPage />} />
<Route
                  path="/employees"
                  element={
                    <RequireRoles roles={['admin', 'owner', 'super_admin', 'hr', 'accountant']}>
                      <Pages.EmployeesPage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/payroll"
                  element={
                    <RequireRoles roles={['admin', 'owner', 'super_admin', 'hr', 'accountant']}>
                      <Pages.PayrollPage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/expense-approvals"
                  element={
                    <RequireRoles roles={['admin', 'owner', 'super_admin', 'hr', 'accountant']}>
                      <Pages.HrExpenseApprovalPage />
                    </RequireRoles>
                  }
                />
<Route path="/leave-requests" element={<Pages.LeavePage />} />
{/* 2026-10-07 (Manak) Apps & Training — HR + admin; the profile menu admits P17/P18 only. */}
<Route path="/hr/mobile-apps" element={<RequireRoles roles={['admin', 'owner', 'super_admin', 'hr']}><Pages.MobileAppsPage /></RequireRoles>} />
<Route path="/hr/app-tour-progress" element={<RequireRoles roles={['admin', 'owner', 'super_admin', 'hr']}><Pages.AppTourProgressPage /></RequireRoles>} />
<Route path="/incentives" element={<Pages.IncentivesPage />} />
<Route
                  path="/hr/recruitment"
                  element={
                    <RequireCapability capability="recruitment">
                      <RequireRoles roles={['owner', 'admin', 'super_admin', 'hr']}>
                        <Pages.RecruitmentPage />
                      </RequireRoles>
                    </RequireCapability>
                  }
                />
<Route path="/service" element={<Navigate to="/service-tickets" replace />} />
<Route path="/service/tickets" element={<Navigate to="/service-tickets" replace />} />
  </>;
}
